import { bindServices } from '@/services/api';

import { MODEL_NAME, ROUTES } from './constants';

const api = bindServices(MODEL_NAME);

const initialState = {
  open: false,
  processId: null,
  processName: null,
  data: null,
};

const Model = {
  namespace: MODEL_NAME,
  state: initialState,
  effects: {
    *openDrawer({ payload }, { put }) {
      const processId = payload?.processId;
      if (!processId) return;

      yield put({
        type: 'setDrawer',
        payload: {
          open: true,
          processId,
          processName: payload?.processName || null,
          data: null,
        },
      });
      yield put({ type: 'fetch', payload: { processId } });
    },

    *closeDrawer(_, { put }) {
      yield put({ type: 'global/clearValidationForm' });
      yield put({ type: 'reset' });
    },

    *fetch({ payload }, { call, put }) {
      const processId = payload?.processId;
      if (!processId) return;

      try {
        const data = yield call(api.getAll, {
          route: ROUTES.instanceNumbering(processId),
          readPriority: true,
        });
        yield put({ type: 'setDrawer', payload: { processId } });
        yield put({ type: 'setData', payload: data });
      } catch (e) {
        // Global error handling
      }
    },

    *save({ payload }, { call, put, select }) {
      const { processId } = yield select((state) => state[MODEL_NAME]);
      if (!processId) return;

      try {
        const data = yield call(api.update, {
          route: ROUTES.instanceNumbering(processId),
          data: {
            instancesNamePattern: payload.instancesNamePattern,
            lastGeneratedNumber: payload.lastGeneratedNumber,
          },
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'global/clearValidationForm' });
        // Prefer server entity; always keep the submitted pattern for Process edit sync.
        yield put({
          type: 'setData',
          payload: {
            ...(data && typeof data === 'object' ? data : {}),
            instancesNamePattern: payload.instancesNamePattern,
            lastGeneratedNumber: Number(payload.lastGeneratedNumber) || 0,
          },
        });
        yield put({ type: 'setDrawer', payload: { open: false } });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
        // Refresh so concurrent allocate raises the floor for LGN.
        yield put({ type: 'fetch', payload: { processId } });
      }
    },
  },
  reducers: {
    setDrawer(state, { payload }) {
      return { ...state, ...payload };
    },
    setData(state, { payload }) {
      return { ...state, data: payload };
    },
    reset() {
      return initialState;
    },
  },
};

export default Model;
